import { Injectable, inject } from '@angular/core';
import { EnvService } from '@src/app/modules/env';
import { lastValueFrom, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppService as ApiAppService } from '@src/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private readonly getService = inject(ApiAppService);
  private readonly env = inject(EnvService);
  private readonly translateService = inject(TranslateService);

  async isCurrentVersionUnsupported(): Promise<boolean> {
    const versionLength = 3;
    const supportedVersion = await lastValueFrom(this.getVersion());
    const clientVersion = require('../../../package.json').version;

    const minimalVersion = this.splitVersion(supportedVersion);
    const currentVersion = this.splitVersion(clientVersion);

    if (minimalVersion.length !== versionLength || currentVersion.length !== versionLength) {
      throw new Error(this.translateService.instant('components.app.alerts.errors.incorrectVersionLength'));
    }

    let index: number = 0;
    while (currentVersion[index] === minimalVersion[index] && index < versionLength) index += 1;

    return currentVersion[index] < minimalVersion[index];
  }

  private getVersion(): Observable<string> {
    return this.getService.version().pipe(
      catchError(err => {
        // TODO show error notification
        return throwError(() => err);
      }),
    );
  }

  private splitVersion(version: string) {
    return version.split('.').map(v => {
      const value = Number(v);

      if (Number.isNaN(value)) {
        throw new Error(this.translateService.instant('components.app.alerts.errors.incorrectVersion'));
      }

      return value;
    });
  }
}
